'use strict';

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _iterator = require('babel-runtime/core-js/symbol/iterator');

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _helpers = require('../../helpers');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable prefer-destructuring */
var GroupedDictionary = function GroupedDictionary(groupedMap, customGetUniqueLabel) {
  var _this = this;

  _classCallCheck(this, GroupedDictionary);

  this.getGroupTitle = function (value) {
    return _this.groupTitleMap[value];
  };

  this.getGroupTitles = function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return values.map(_this.getGroupTitle).join(', ');
  };

  this.getLabel = function (value) {
    return _this.labelMap[value];
  };

  this.getLabels = function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return values.map(_this.getLabel).join(', ');
  };

  this.getUniqueLabel = function (optionOrValue) {
    if (!optionOrValue) {
      return '';
    }

    var value = void 0;
    var groupId = void 0;
    var label = void 0;

    if ((typeof optionOrValue === 'undefined' ? 'undefined' : _typeof(optionOrValue)) === 'object') {
      // Parameter is option
      value = optionOrValue.value;
      groupId = optionOrValue.groupId;
      label = optionOrValue.label;
    } else {
      // Parameter is value
      value = optionOrValue;
      groupId = _this.getGroupTitle(value);
      label = _this.getLabel(value);
    }

    return _this.customGetUniqueLabel({ value: value, groupId: groupId, label: label });
  };

  this.getUniqueLabels = function () {
    var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return values.map(_this.getUniqueLabel).join(', ');
  };

  this.customGetUniqueLabel = customGetUniqueLabel || _helpers.getUniqueLabel;

  this.groups = [];
  this.options = [];
  this.values = [];

  this.groupTitleMap = {};
  this.labelMap = {};

  // http://furqanzafar.github.io/react-selectize/#/?category=multi&example=option-groups
  // Generate groups and options in the shape of React Selectize MultiSelect props
  (0, _keys2.default)(groupedMap).forEach(function (groupTitle) {
    _this.groups.push({
      groupId: groupTitle,
      title: groupTitle
    });

    var group = groupedMap[groupTitle];

    (0, _keys2.default)(group).forEach(function (value) {
      var label = group[value];

      // Map values to group titles and labels (used for lookup by getter methods)
      _this.groupTitleMap[value] = groupTitle;
      _this.labelMap[value] = label;

      // Collect flattened values and options
      _this.values.push(value);
      _this.options.push({
        value: value,
        label: label,
        groupId: groupTitle
      });
    });
  });
}

// Used to retrieve unique label for selected option or a standalone value
;

exports.default = GroupedDictionary;